import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { CmsService, I18nModule } from "@spartacus/core";
import { ICON_TYPE, IconModule } from "@spartacus/storefront";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { toSignal } from "@angular/core/rxjs-interop";
import { CustomProfileAndPreferencesService } from "../../../custom-profile-and-preferences/custom-profile-and-preferences.service";

@Component({
  selector: 'app-add-phone-number-banner',
  standalone: true,
  imports: [
    I18nModule,
    IconModule
  ],
  templateUrl: './add-phone-number-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddPhoneNumberBannerComponent {
  private readonly user = inject(UserAccountFacade);
  private readonly cmsService = inject(CmsService);
  private readonly pfService = inject(CustomProfileAndPreferencesService);

  protected readonly iconTypes = ICON_TYPE;

  visible = signal(true);
  readonly currentPage = toSignal(this.cmsService.getCurrentPage());
  readonly pfUser = toSignal<any>(this.pfService.userData);

  constructor() {
  }
}
